import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

import { RootStateContext } from "../../states/root.state";
import { LegacyUserImport } from "../../types/legacy";
import ExcelFileDrop from "../form/excelFileDrop.comp";
import ExcelFileInput from "../form/excelFileInput.comp";

export default function ImportLegacyUser() {
  const [excelData, setExcelData] = useState<LegacyUserImport[] | null>(null);
  const { push } = useRouter();
  const { legacyUserImportService } = useContext(RootStateContext);

  useEffect(() => {
    if (!excelData) return;

    legacyUserImportService.send({ type: "SELECT_FILE", users: excelData });
    push("/import/legacyUser/list");

    // eslint-disable-next-line
  }, [excelData]);

  useEffect(() => {
    legacyUserImportService.stop();
    legacyUserImportService.start();

    // eslint-disable-next-line
  }, []);

  return (
    <section data-type="section" className="space-y-4">
      <h2>Legacy User Import</h2>
      <ExcelFileDrop setExcelData={setExcelData} />
      <ExcelFileInput setExcelData={setExcelData} />
    </section>
  );
}
